var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex justify-content-center text-wrap cursor-pointer",on:{"click":function($event){return _vm.openCompanyDetails()}}},[_c('badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Open company details"}},[_vm._v(_vm._s(_vm.task.company.companyName)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }